
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"45","viewBox":"0 0 45 45","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22.5 2.9569C11.7066 2.9569 2.9569 11.7066 2.9569 22.5C2.9569 33.2934 11.7066 42.0431 22.5 42.0431C33.2934 42.0431 42.0431 33.2934 42.0431 22.5C42.0431 11.7066 33.2934 2.9569 22.5 2.9569ZM0 22.5C0 10.0736 10.0736 0 22.5 0C34.9264 0 45 10.0736 45 22.5C45 34.9264 34.9264 45 22.5 45C10.0736 45 0 34.9264 0 22.5ZM33.2571 15.8613C33.8345 16.4386 33.8346 17.3747 33.2573 17.9522L22.0684 29.1437C21.4911 29.7211 20.5551 29.7212 19.9777 29.144L13.7406 22.9096C13.1631 22.3323 13.1629 21.3962 13.7401 20.8187C14.3174 20.2412 15.2535 20.2411 15.831 20.8183L21.0225 26.0076L31.1662 15.8616C31.7435 15.2841 32.6796 15.284 33.2571 15.8613Z","fill":"#00C334"}})])
          )
        }
      }
    